exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.v_align {\n  vertical-align: top;\n}\n.period {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\ninput#periodAmt {\n  width: 150px;\n  margin-left: 20px;\n}\nselect#periodUnit {\n  margin-left: 5px;\n  width: 100px;\n}\n.result-bold {\n  font-weight: bold;\n}\n.result-center {\n  text-align: center;\n}\n.hideForm {\n  display: none;\n}\n", ""]);

// exports
